import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import { useQuery } from "@tanstack/react-query";
import { getRequest } from "../services/apiMethods";
import { filterTheArray } from "../utils/HelperFunctions";
import { decisionOptions, needOptions } from "../utils/commanFiles";
import Notes from "./Notes";
import moment from "moment";

const ResponsesDetail = ({ selectedId, initialId }) => {
  const { data: responceData, refetch } = useQuery({
    queryKey: ["responcedetail"],
    queryFn: () =>
      getRequest(
        `/lead/purchase/details?purchaseId=${selectedId ? selectedId : initialId
        }`
      ),
    enabled: !!(selectedId || initialId),
  });

  useEffect(() => {
    if (selectedId) {
      refetch();
    }
  }, [selectedId]);

  const responceDetailData = responceData?.data?.lead;

  return (
    <div>
      {responceDetailData ? (
        <div className="comnn-layout-main">
          <div className="comnn-pro-details">
            <div>
              <h3>{responceDetailData?.customer?.name}</h3>
              <p>
                {responceDetailData?.city ||
                  `${filterTheArray(
                    responceDetailData?.address
                  )}, ${responceDetailData?.postCode?.slice(0, 3)}`}
              </p>
              {responceDetailData?.customer?.isPhoneNoVerified &&
                <div className="hidden-data-details">
                  <p>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                    >
                      <path
                        d="M13.7071 11.7071L16.3552 14.3552C16.7113 14.7113 16.7113 15.2887 16.3552 15.6448C14.43 17.57 11.3821 17.7866 9.20399 16.153L7.62857 14.9714C5.88504 13.6638 4.33622 12.115 3.02857 10.3714L1.84701 8.79601C0.213407 6.61788 0.430014 3.56999 2.35523 1.64477C2.71133 1.28867 3.28867 1.28867 3.64477 1.64477L6.29289 4.29289C6.68342 4.68342 6.68342 5.31658 6.29289 5.70711L5.27175 6.72825C5.10946 6.89054 5.06923 7.13846 5.17187 7.34373C6.35853 9.71706 8.28294 11.6415 10.6563 12.8281C10.8615 12.9308 11.1095 12.8905 11.2717 12.7283L12.2929 11.7071C12.6834 11.3166 13.3166 11.3166 13.7071 11.7071Z"
                        stroke="black"
                      />
                    </svg>

                    {`+${responceDetailData?.customer?.countryCode} ${responceDetailData?.customer?.phoneNumber}`}
                  </p>


                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="17"
                    height="17"
                    viewBox="0 0 17 17"
                    fill="none"
                  >
                    <rect
                      width="15"
                      height="15"
                      rx="7.5"
                      transform="matrix(-1 0 0 1 16 1)"
                      stroke="#27CA40"
                    />
                    <path
                      d="M11.7812 6.75812L7.24578 10.6095L5.21875 8.58245"
                      stroke="#27CA40"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>

                </div>}
              <div className="hidden-data-details">
                <p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="17"
                    viewBox="0 0 20 17"
                    fill="none"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M0.771209 2.8697C0.937745 2.784 1.13821 2.79856 1.29062 2.90742L9.12814 8.50565C9.64969 8.87818 10.3503 8.87818 10.8719 8.50565L18.7094 2.90742C18.8618 2.79856 19.0623 2.784 19.2288 2.8697C19.3953 2.95541 19.5 3.12699 19.5 3.31429V14.3C19.5 15.6807 18.3807 16.8 17 16.8H3C1.61929 16.8 0.5 15.6807 0.5 14.3V3.31429C0.5 3.12699 0.604674 2.95541 0.771209 2.8697ZM1.5 4.28588V14.3C1.5 15.1284 2.17157 15.8 3 15.8H17C17.8284 15.8 18.5 15.1284 18.5 14.3V4.28588L11.4531 9.31938C10.5839 9.94027 9.41615 9.94027 8.5469 9.31938L1.5 4.28588Z"
                      fill="black"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M0.5 3C0.5 1.61929 1.61929 0.5 3 0.5H17C18.3807 0.5 19.5 1.61929 19.5 3V3.57159L11.4531 9.31938C10.5839 9.94027 9.41615 9.94027 8.5469 9.31938L0.5 3.57159V3ZM3 1.5C2.17157 1.5 1.5 2.17157 1.5 3V3.05698L9.12814 8.50565C9.64969 8.87818 10.3503 8.87818 10.8719 8.50565L18.5 3.05698V3C18.5 2.17157 17.8284 1.5 17 1.5H3Z"
                      fill="black"
                    />
                  </svg>
                  {/* tonysmith12@gmail.com */}
                  {responceDetailData?.email}
                </p>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  fill="none"
                >
                  <rect
                    width="15"
                    height="15"
                    rx="7.5"
                    transform="matrix(-1 0 0 1 16 1)"
                    stroke="#27CA40"
                  />
                  <path
                    d="M11.7812 6.75812L7.24578 10.6095L5.21875 8.58245"
                    stroke="#27CA40"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div className=" send-emil-es-btn">
                <button className="theme-comm-btn">
                  {" "}
                  <a
                    href={`mailto:${responceDetailData?.email}`}
                    style={{
                      textDecoration: "none",
                      color: "white",
                    }}
                  >
                    Send Email{" "}
                  </a>
                </button>
              {responceDetailData?.customer?.isPhoneNoVerified &&
                <button className="theme-comm-btn">
                  <a
                    href={`tel:+${responceDetailData?.countryCode}${responceDetailData?.phoneNumber}`}
                    style={{
                      textDecoration: "none",
                      color: "white",
                    }}
                  >
                    Call Client
                  </a>
                </button>}
              </div>
            </div>

            <div>
              {responceDetailData?.createdAt && <p>
                {moment(responceDetailData?.createdAt).format("DD MMMM YYYY")}
              </p>}
              {responceDetailData?.createdAt && <p>
                {moment(responceDetailData?.createdAt).format('LT')}
              </p>}
            </div>
          </div>
          <div className="detail-para">
            <Tab.Container id="left-tabs-example" defaultActiveKey="first">
              <Row className="comn-page-switch">
                <Col sm={12}>
                  <Nav variant="pills" className="">
                    <Nav.Item>
                      <Nav.Link eventKey="first">Lead Details</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">Notes</Nav.Link>
                    </Nav.Item>
                  </Nav>
                </Col>
                <Col sm={12}>
                  <Tab.Content>
                    <Tab.Pane eventKey="first">
                      <div className="detail-para-txt">

                      <div className="detail-para-txt">
                        <p>Service</p>
                        <p>{responceDetailData?.service?.serviceName}</p>
                      </div>


                        <p>Category</p>
                        <p>{responceDetailData?.category?.categoryName}</p>
                      </div>

                      <div className="detail-para-txt">
                        <p>Is it for a Home or a Business?</p>
                        <p>{responceDetailData?.businessType}</p>
                      </div>

                      {responceDetailData?.propertyType &&
                            <div class="detail-para-txt">
                                <p>What type of property is it?</p>
                                <p>{responceDetailData?.propertyType}</p>
                            </div>

                        }

<div className="detail-para-txt">
                        <p>Have you had any quotes before?</p>
                        <p>{responceDetailData?.quotation}</p>
                      </div>

                    
                      {responceDetailData?.estimatedBudget && (
                        <div className="detail-para-txt">
                          <p>Do you have an estimated budget?</p>
                          <p>£{responceDetailData?.estimatedBudget}</p>
                        </div>
                      )}
                 

                      <div className="detail-para-txt">
                        <p>Do you have an estimated start date?</p>
                        {needOptions
                          .filter(
                            (e) => e.value == responceDetailData?.needType
                          )
                          .map((ele, idx) => {
                            return <p key={idx}>{ele?.value}</p>;
                          })}
                      </div>
                      <div className="detail-para-txt">
                        <p>How likely are you to make a decision?</p>
                        {decisionOptions
                          .filter(
                            (e) => e.value == responceDetailData?.decisionType
                          )
                          .map((ele, idx) => {
                            return <p key={idx}>{ele?.label}</p>;
                          })}
                      </div>
                      <div className="detail-para-txt">
                        <p>A brief description of your requirements</p>
                        <p>{responceDetailData?.taskDescription}</p>
                      </div>
                    </Tab.Pane>
                    <Tab.Pane eventKey="second">
                      <div className="note-view-leads">
                        <Notes selectedId={selectedId} initialId={initialId} />
                      </div>
                    </Tab.Pane>
                  </Tab.Content>
                </Col>
              </Row>
            </Tab.Container>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default ResponsesDetail;
